/* eslint-disable prettier/prettier */
import React from 'react';
import { useDispatch } from 'react-redux';
import TextInfo, {
  TEXT_INFO_COLOR,
  TEXT_INFO_HEADING_LEVEL,
  TEXT_INFO_SIZE,
  TEXT_INFO_FONT_WEIGHT,
  TEXT_INFO_KIND,
} from '@gcloud-npm/next12.components.text-info';
import CustomLink from '@gcloud-npm/next12.components.custom-link';
import Icon from '@gcloud-npm/next12.components.icon';
import {
  actions as modalActions,
  ELEMENT_TYPES,
} from '@gcloud-npm/next12.app-controller.reducers-sagas.modals-reducer';
import { LegalConditionsModalCss } from './styles';

const Modal = (props) => {
  const { title, taggingInfo, description } = props;
  const dispatch = useDispatch();

  const onClickHandler = () => {
    dispatch(
      modalActions.addModal({
        type: ELEMENT_TYPES.MODAL,
        id: '',
      })
    );
  };

  return (
    <div className="legal-conditions-modal">
      <div className="modal__header">
        {title && (
          <TextInfo
            className="title"
            kind={TEXT_INFO_KIND.HEADING}
            level={TEXT_INFO_HEADING_LEVEL.H3}
            color={TEXT_INFO_COLOR.WHITE}
            size={TEXT_INFO_SIZE.TITLE3}
            fontType={TEXT_INFO_FONT_WEIGHT.LIGHT}
            text={title}
          />
        )}
        <CustomLink
          className="modal__close"
          onClick={onClickHandler}
          taggingInfo={taggingInfo}
          title="Cerrar modal"
          ariaLabel="Cerrar modal"
        >
          <Icon id="Cerrar" segment="gp" color="white" size={14} />
        </CustomLink>
      </div>
      <div className="modal__content">
        <TextInfo
          className="description"
          kind={TEXT_INFO_KIND.PARAGRAPH}
          size={TEXT_INFO_SIZE.CAPTION1}
          color={TEXT_INFO_COLOR.GREY_5}
          text={description}
        />
      </div>
      <style jsx>{LegalConditionsModalCss}</style>
    </div>
  );
};

export default Modal;
